<div class="cabboton container p-3 my-3 bg-cabimp text-white">
     <button  class="btn btn-cave" (click)="volver()">
       <fa-icon [icon]="icoRet"></fa-icon>  Volver
     </button>
      <button style="margin-left:5px;" class="btn btn-success" onClick="window.print()">
       <fa-icon [icon]="icoPrn"></fa-icon>  Imprimir
     </button>
</div>
<div style="text-align: center;">
  <div *ngIf="resul" class="spinner-border text-primary" role="status"></div>
</div>

<div class="cuerpo">
    <img id="cabdoc" src="../../assets/img/cabdoc.png"  alt=""  width="500"  class="d-inline-block align-top" >
    <div class="separador"> </div>
    <h2 class="heading" style="text-align: center;">FICHA DE APORTACIÓN A CAPITAL </h2>
    <h3 class="heading" style="text-align: center;">{{nomusu}} </h3>

    <table id="tabla" class="table table-bordered row-border hover">
            <thead>
              <tr>
                <th >Fecha</th>
                <th >Concepto</th>
                <th >Arrobas Tintas</th>
                <th >Arrobas Blancas</th>
                <th >Capital Suscrito</th>
                <th >Capital Desemb.</th>
                <th >Pendiente Parcial</th>
                <th >Pendiente Total</th>
              </tr>
            </thead> 
            <tbody>
              <tr *ngFor="let dato of datosTabla"> 
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}">{{ dato.cpFecha }}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}">{{ dato.cpConce }}</td> 
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpArbTi | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpArbBl | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpSuscr | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpDesem | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpPdPar | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpPdTot | number: '.2'}}</td> 

              </tr> 
            </tbody> 
    </table>
  
</div>



